import {Languages} from '@shared/languages';

import {FormSubmissionState} from '@shared/SupportModal/FormContentOrResultView/types';
import {FormRequestTypeBase} from '@shared/SupportModal/types';

export async function acceptStrapiForm<T>(
  apiUrl: string,
  data: FormRequestTypeBase<T>,
  endpoint: string,
  locale: Languages,
): Promise<{
  result: Exclude<FormSubmissionState, 'initial'>;
  errorDetail?: unknown;
}> {
  try {
    const result = await fetch(apiUrl, {
      method: 'POST',
      redirect: 'manual',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({...data, nextUrl: endpoint, locale}),
    });

    return {
      result: result.ok ? 'success' : 'error',
      errorDetail: result.type === 'opaqueredirect' ? 302 : result.status,
    };
  } catch (e) {
    return {result: 'error', errorDetail: e};
  }
}
